import * as React from "react";
import { Box, Stack, Tab, Tabs, Typography } from "@mui/material";
import ReceivablesTab from "./tabs/ReceivablesTab";
import InvoicesTab from "./tabs/InvoicesTab";
import PayablesTab from "./tabs/PayablesTab";
import ManhoursTab from "./tabs/ManhoursTab";
import ProfitLossTab from "./tabs/ProfitLossTab";
import { MISProvider } from "./MISContext";
import DeviationTable from "./tabs/DeviationTableTab";

const sectionTitleSx = {
  border: "1px solid #d9d9d9",
  borderRadius: "6px",
  padding: "4px 10px",
  display: "inline-block",
  backgroundColor: "#fff",
  fontWeight: 600,
};

function TabPanel({ value, index, children }) {
  if (value !== index) return null;
  return <Box sx={{ pt: 2 }}>{children}</Box>;
}

export default function MISTab() {
  const [value, setValue] = React.useState(0);

  const tabs = [
    { label: "Progress", panel: <ReceivablesTab /> },
    { label: "Invoices", panel: <InvoicesTab /> },
    { label: "A\\C Payables", panel: <PayablesTab /> },
    { label: "Manhours Loading", panel: <ManhoursTab /> },
    { label: "Profit & Loss", panel: <ProfitLossTab /> },
    { label: "Deviation", panel: <DeviationTable /> },
  ];

  const handleChange = (_, newValue) => {
    setValue(newValue);
  };

  return (
    <MISProvider>
      <Box sx={{ width: "100%", p: 2 }}>
        <Stack spacing={2} alignItems="center">
          <Typography variant="subtitle1" sx={sectionTitleSx}>
            Management Information system (MIS) - Dashboard
          </Typography>
        </Stack>
        <Tabs value={value} onChange={handleChange} sx={{ mt: 2 }}>
          {tabs.map((tab) => (
            <Tab key={tab.label} label={tab.label} />
          ))}
        </Tabs>
        {tabs.map((tab, index) => (
          <TabPanel key={tab.label} value={value} index={index}>
            {tab.panel}
          </TabPanel>
        ))}
      </Box>
    </MISProvider>
  );
}
